module.exports = __webpack_public_path__ + "media/images/emblems/Ruetschelen-coat_of_arms-0ff5767a03fd1d8951000348ddd1d642.svg";